import styled from 'styled-components';

export const LegalLinksContainer = styled.div`
  padding: 1rem;

  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  line-height: ${({ theme }) => theme.typography.body2.lineHeight};
`;
